var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoneLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    viewBox: "0 0 30 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_811)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_178_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 41.7117C16.8602 41.5188 8.50022 33.0401 8.5 22.6082C8.5 12.176 16.8601 3.69848 27.2461 3.50562C27.2784 3.74461 27.3089 4.09957 27.335 4.56812C27.3895 5.54928 27.4267 6.97666 27.4512 8.74976C27.5001 12.2938 27.5 17.1921 27.5 22.6082C27.5 28.0239 27.5001 32.9216 27.4512 36.4656C27.4267 38.2387 27.3895 39.666 27.335 40.6472C27.3088 41.117 27.2785 41.4726 27.2461 41.7117Z",
    stroke: "url(#paint0_linear_178_811)",
    strokeOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_178_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 23.5197C3 20.2485 3.18785 20.2156 6.459 20.2156C6.69592 20.2156 6.69592 20.2485 6.69592 23.5197C6.69592 26.7908 6.69592 27.2156 6.459 27.2156C3 27.2156 3 26.7908 3 23.5197Z",
    fill: "#00D9FF",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 41.7117C16.8602 41.5188 8.50022 33.0401 8.5 22.6082C8.5 12.176 16.8601 3.69848 27.2461 3.50562C27.2784 3.74461 27.3089 4.09957 27.335 4.56812C27.3895 5.54928 27.4267 6.97666 27.4512 8.74976C27.5001 12.2938 27.5 17.1921 27.5 22.6082C27.5 28.0239 27.5001 32.9216 27.4512 36.4656C27.4267 38.2387 27.3895 39.666 27.335 40.6472C27.3088 41.117 27.2785 41.4726 27.2461 41.7117Z",
    stroke: "url(#paint1_linear_178_811)",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 23.5197C3 20.2485 3.18785 20.2156 6.459 20.2156C6.69592 20.2156 6.69592 20.2485 6.69592 23.5197C6.69592 26.7908 6.69592 27.2156 6.459 27.2156C3 27.2156 3 26.7908 3 23.5197Z",
    fill: "#00D9FF",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_178_811",
    x: 4,
    y: -1,
    width: 28,
    height: 47.2156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_178_811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_178_811",
    x: -1,
    y: 16.2156,
    width: 11.6959,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_178_811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_811",
    x1: 28.8824,
    y1: 22.6077,
    x2: 6.33334,
    y2: 22.6077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1655DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_811",
    x1: 28.8824,
    y1: 22.6077,
    x2: 6.33334,
    y2: 22.6077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1655DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoneLeft);
export default __webpack_public_path__ + "static/media/foneLeft.de5c1e9b53658cc3e5d3b3865b25090b.svg";
export { ForwardRef as ReactComponent };